(function () {
	function getDisclosure(option) {
		return option.closest('.ec-facet-sort__disclosure')
	}

	function getInput(disclosure) {
		return disclosure.querySelector('.ec-facet-sort__input')
	}

	function getValueEl(disclosure) {
		return disclosure.querySelector('[data-ec-sort-value]')
	}

	function setActiveOption(disclosure, activeOption) {
		disclosure.querySelectorAll('.ec-facet-sort__option').forEach((option) => {
			const isActive = option === activeOption
			option.classList.toggle('ec-facet-sort__option--active', isActive)
			if (isActive) {
				option.setAttribute('aria-current', 'true')
			} else {
				option.removeAttribute('aria-current')
			}
		})
	}

	function closeDisclosure(disclosure) {
		disclosure.removeAttribute('open')
		disclosure.classList.remove('ec-opening', 'ec-closing')
		const summary = disclosure.querySelector('.ec-facet-sort__summary')
		if (summary) summary.setAttribute('aria-expanded', 'false')
	}

	function submitSort(disclosure) {
		const input = getInput(disclosure)
		const form = input?.closest('form')
		if (form && input) {
			input.dispatchEvent(new Event('input', { bubbles: true }))
		}
	}

	document.addEventListener('click', function (event) {
		const option = event.target.closest('.ec-facet-sort__option')
		if (!option) return

		event.preventDefault()
		event.stopPropagation()

		const disclosure = getDisclosure(option)
		if (!disclosure) return

		const input = getInput(disclosure)
		const value = option.dataset.value
		const label = option.textContent.trim()

		if (!input || !value) return

		if (input.value === value) {
			closeDisclosure(disclosure)
			return
		}

		input.value = value

		const valueEl = getValueEl(disclosure)
		if (valueEl) valueEl.textContent = label

		setActiveOption(disclosure, option)
		closeDisclosure(disclosure)
		submitSort(disclosure)
	})

	document.addEventListener('toggle', function (event) {
		const disclosure = event.target
		if (!disclosure.classList?.contains('ec-facet-sort__disclosure')) return

		const summary = disclosure.querySelector('.ec-facet-sort__summary')
		if (!summary) return

		const isOpen = disclosure.hasAttribute('open')
		summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false')

		if (isOpen) {
			disclosure.classList.add('ec-opening')
			disclosure.classList.remove('ec-closing')
		} else {
			disclosure.classList.remove('ec-opening', 'ec-closing')
		}
	}, true)
})()
